export default function compressApiFetchParams(params) {
  return {
    ...params,
    fields:
      params?.fields && Object.fromEntries(Object.entries(params.fields).map(([key, vals]) => [key, vals.join(',')])),
    include: params?.include && params.include.join(','),
  };
}
